import I18n from 'I18n';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import { ME, MY_TEAM, MY_USER_ID, ALL_DEACTIVATED_OWNERS } from './specialFieldValues';
export const getDeactivatedOwersOption = () => PropertyOptionRecord({
  icon: 'dynamicFilter',
  label: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorOwnerInput.allDeactivatedOwners'),
  value: ALL_DEACTIVATED_OWNERS
});
export const getMeOption = () => PropertyOptionRecord({
  icon: 'dynamicFilter',
  label: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.me'),
  value: ME,
  description: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.meDescription')
});

/**
 * Note: The My Team option is only applicable in Reporting
 */
export const getMyTeamOption = () => PropertyOptionRecord({
  icon: 'dynamicFilter',
  label: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.myTeam'),
  value: MY_TEAM,
  description: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.myTeamDescription')
});

/**
 * Note: The getMyUserIdOptionis only applicable in Reporting
 */
export const getMyUserIdOption = () => PropertyOptionRecord({
  icon: 'dynamicFilter',
  label: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.myUserId'),
  value: MY_USER_ID,
  description: I18n.text('customerDataFiltersUI.customerDataFilters.specialFields.myUserIdDescription')
});